import * as styles from "./DrawerBackdrop.css";

import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";

import type { DrawerBackdropProps } from "./Drawer.types";

export function DrawerBackdrop({ ...props }: DrawerBackdropProps): JSX.Element {
  return (
    <BaseDrawer.Backdrop
      data-slot="drawer-backdrop"
      className={styles.backdrop}
      {...props}
    />
  );
}
